function addToCart(addData) {
  
}

function updateCart(data) {
  
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

//     this.lineItemStatusElement = this.querySelector('.shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.mainCartItems = document.querySelector('#main-cart-items');
    this.quickAddLinks = document.querySelectorAll('.quick-add--link');
    this.cartDrawer = document.querySelector('cart-drawer');

    this.removeGwp();
   
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  removeGwp() {
    return;
    const removeEl = document.querySelector('#remove-gwp');
    if(!removeEl) return;
    let id = removeEl.getAttribute('data-id');
    const body = JSON.stringify({
      'id': id,
      'quantity': 0,
      'sections': 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer'
    });
    console.clear();
    console.log(body);

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        this.cartDrawer.renderContents(state);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch((error) => {
        console.log(error);
        /*
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelector('.cart-errors').textContent = window.cartStrings.error;
        */
        this.disableLoading();
      });
    
  }


  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.cartDrawer.getSectionsToRender().map((section) => section.id)
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        if(window.location.href.indexOf('/cart') !== -1) {
          console.clear();
          console.log("reloading");
          window.location.reload();
        }
        this.cartDrawer.renderContents(state);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelector('.cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
//     this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    
    if(this.mainCartItems) {
      this.mainCartItems.classList.add('cart__items--disabled');
    }
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
//     this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    if(this.mainCartItems) {
      this.mainCartItems.classList.remove('cart__items--disabled');
    }

  }
}

customElements.define('cart-items', CartItems);



class GiftNoteToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click',this.toggleGiftNote.bind(this));
  }
  toggleGiftNote(e) {
    e.preventDefault();
    console.log('gift-note-toggle');
    const giftNoteEl = document.getElementById('drawer__gift-note');
    
    const isOpen = this.getAttribute('aria-expanded') === 'true'
    this.setAttribute('aria-expanded',!isOpen);
    // if (!giftNoteEl.classList.contains('active')) {

    //   giftNoteEl.classList.add('active');
    //   giftNoteEl.style.height = 'auto';

    //   var height = giftNoteEl.clientHeight + 'px';

    //   giftNoteEl.style.height = '0px';

    //   setTimeout(function () {
    //     giftNoteEl.style.height = height;
    //   }, 0);

    // } else {

    //   giftNoteEl.style.height = '0px';

    //   giftNoteEl.addEventListener('transitionend', function () {
    //     giftNoteEl.classList.remove('active');
    //   }, {
    //     once: true
    //   });

    // }
  }
}

customElements.define('gift-note-toggle',GiftNoteToggle);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    //     this.addEventListener('change', this.onCartChange);
    this.mainCartItems = document.querySelector('#main-cart-items');

    this.quickAddLinks = document.querySelectorAll('.quick-add--link');

    this.cartTriggers = document.querySelectorAll('[data-drawer-trigger]');
    this.cartDrawer = document.querySelector('[data-drawer-target]');
    this.cartClosers = document.querySelectorAll('[data-drawer-close]');

    this.cartDrawer.classList.add('is-active');
    
    this.cartTriggers.forEach(cartTrigger => {
      cartTrigger.addEventListener('click', e => {
        e.preventDefault();
        this.open()
      });
    });
                              
    this.cartClosers.forEach(cartCloser => {
      cartCloser.addEventListener('click', e => {
        this.close();     
      });
    });
    this.checkUpsells();

    
  }
  
  toggleGiftNote(e) {
    e.preventDefault();
    const giftNoteEl = document.getElementById('drawer__gift-note');
    if (!giftNoteEl.classList.contains('active')) {

      giftNoteEl.classList.add('active');
      giftNoteEl.style.height = 'auto';

      var height = giftNoteEl.clientHeight + 'px';

      giftNoteEl.style.height = '0px';

      setTimeout(function () {
        giftNoteEl.style.height = height;
      }, 0);

    } else {

      giftNoteEl.style.height = '0px';

      giftNoteEl.addEventListener('transitionend', function () {
        giftNoteEl.classList.remove('active');
      }, {
        once: true
      });

    }
  }
  
  open() {
    this.cartDrawer.classList.add('is-visible');
    document.querySelector('html').classList.add('overflow-hidden');
  }

  close() {
    this.cartDrawer.classList.remove('is-visible');
    document.querySelector('html').classList.remove('overflow-hidden');
  }
  
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      console.log(section);
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    this.open();
    this.checkUpsells();
    
    lazyLoadImages();
  }

  getSectionsToRender() {
    let sectionsOnPage = [
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.drawer__wrapper'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
    
    if(this.mainCartItems) {
      sectionsOnPage.push(
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }
      );
    }
    return sectionsOnPage;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  
  checkUpsells() {
    const cartItems = this.querySelector('.drawer__items');
    if(!cartItems) return;
    
    const cartJson = JSON.parse(cartItems.getAttribute('data-json'));
    if(!cartJson) return;
    if(cartJson[0].product_title.indexOf(' - ') === -1) return;
    
    const productTitle = cartJson[0].product_title.split(' - ');
    const productId = cartJson[0].product_id;
    const productTitleArray = productTitle[0].split(' ');
    const productType = cartJson[0].product_type;
    const productColor = productTitle[1];
    
    if(productId === parseFloat(getCookie('hide_wear_with'))) return;

    let globalEData = getCookie('GlobalE_Data');
    let gwpWrapper = document.querySelector('.gwp__wrapper');
    let globalEJson = JSON.parse(decodeURIComponent(globalEData));
    
    if(globalEJson && globalEJson.countryISO !== 'US' && gwpWrapper) {
      gwpWrapper.style.display = 'none';
    };

    const searchQuery = `${productColor} -${cartJson[0].handle}`;
    const searchUrl = `/search?q=${searchQuery}&type=product&view=wear-with`;
    const wearWithEl = document.querySelector('.wear-with__cart');
    const wearWithWrapper = document.querySelector('.wear-with__wrapper');

    
    fetch(searchUrl)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var wearWithItem = doc.querySelector('.wear-with__item');
      
      if(!wearWithItem) {
        wearWithWrapper.style.display = 'none';
        return;
      }
      wearWithWrapper.style.display = 'block';
      wearWithEl.innerHTML = html;
      wearWithEl.querySelector('.quick-add-bar').classList.remove('small-hide');
      lazyLoadImages();
      wearWithWrapper.querySelector('.wear-with__close').addEventListener('click',event => {
        wearWithWrapper.style.display='none';
        setCookie('hide_wear_with',productId);
      });
      //       document.getElementById('cart-icon-bubble').click();
    })
    .catch(error => console.log(error));
  }
  
  getUpsellProduct(url) {
    fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
    })
    .catch(error => console.log(error));
  }
  
  getUpsellMatch(typeToMatch) {
    let matchFound = false;
    const matchesArray = [
      {
        "name":"Knit Tank",
        "match":"Knit Pants"
      },
      { 
        "name":"Knit Tops",
        "match":"Knit Bottoms" 
      }
    ];
    matchesArray.forEach(matches => {
      if(matches.name !== typeToMatch) return;
      matchFound = matches.match.split(' ').join('+');
    });
    return matchFound;
  }
}

customElements.define('cart-drawer', CartDrawer);


class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.quick-add--link');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.finalSale = this.getAttribute('data-final-sale') === 'true';
    this.buttons.forEach(button => {
      button.addEventListener('click', (event) => {
        if(button.classList.contains('sold-out')) return;
        event.preventDefault();
		this.quickAdd(button);
      });
    });
  }
  enableLoading() {
    this.classList.add('loading');
  }
  disableLoading() {
    this.classList.remove('loading');
  }
  quickAdd(button) {
    this.enableLoading();
    const variantId = parseFloat(button.getAttribute('data-variant-id'));
    const sections = this.cartDrawer.getSectionsToRender().map((section) => section.id);
    const addData = {
      'id': variantId,
      'quantity': 1,
      'sections': sections,
      'sections_url': '/cart'
    };
    if(button.closest('.gwp_selector')) {
      addData['properties'] = {
        '_is_gwp': true
      }
    }
    if(this.finalSale) {
      addData['properties'] = {
        'This item is': "Final Sale"
      }
    }
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),      
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      this.cartDrawer.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally((e) => {
      this.disableLoading();
      console.log(e);
    });
  }
  
  handleErrorMessage(response) {
    this.querySelector('.error').textContent = response;
    this.querySelector('.error').style.display = 'block';
  }
}

customElements.define('quick-add', QuickAdd);


class CartNote extends HTMLElement {
  constructor() {
    super();
    console.log(this);
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      console.log(event.target.value);
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

class PromoCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.button = this.querySelector('.promo-code__apply');
    this.toggle = this.querySelector('#promo-code__toggle');
    this.form = this.querySelector('#promo-code__form');
    this.toggle.addEventListener('click', (event) => {
      let isOpen = this.form.hasAttribute('hidden');
      if(isOpen) {
        this.form.removeAttribute('hidden');
        this.toggle.setAttribute('hidden',true);
      } else {
        this.form.setAttribute('hidden','true');
        this.form.removeAttribute('hidden');
      }
    });
    this.button.addEventListener('click', (event) => {
      if(this.input.value == '') return;
      let discountApplyUrl = "https://" + window.Shopify.shop + "/discount/" + this.input.value;
      // Applies discount using hidden iframe to the checkout session
      fetch(dicountApplyUrl)
      .then(response => response.text())
      .then(data => {
        
      })
      .catch(error => console.log(error));
      
      let i = document.createElement('iframe');
      i.style.display = 'none';
      i.onload = function() { i.parentNode.removeChild(i); };
      i.src=discountApplyUrl;
      document.body.appendChild(i);
      console.log(discountApplyUrl);
    });
  }
}

customElements.define('promo-code', PromoCode);


